document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-lp-testimonials]')
    .forEach((section) => {
      initLpTestimonials(section);
    });
});

function initLpTestimonials(section) {
  const track = section.querySelector('[data-lp-testimonials-track]');
  const viewport = section.querySelector('[data-lp-testimonials-viewport]');
  const reviews = Array.from(section.querySelectorAll('[data-lp-testimonial]'));
  const previousButton = section.querySelector('[data-lp-testimonials-previous]');
  const nextButton = section.querySelector('[data-lp-testimonials-next]');
  const dotsContainer = section.querySelector('[data-lp-testimonials-dots]');

  if (!track || !viewport || !reviews.length || !previousButton || !nextButton) return;

  let currentPage = 0;
  let touchStartX = 0;
  let touchEndX = 0;

  function getReviewsPerPage() {
    return window.matchMedia('(max-width: 900px)').matches ? 1 : 2;
  }

  function getPageCount() {
    return Math.ceil(reviews.length / getReviewsPerPage());
  }

  function normalizeCurrentPage() {
    const pageCount = getPageCount();

    if (currentPage >= pageCount) {
      currentPage = Math.max(0, pageCount - 1);
    }
  }

  function renderDots() {
    if (!dotsContainer) return;

    const pageCount = getPageCount();

    dotsContainer.innerHTML = Array.from(
      { length: pageCount },
      (_, index) => `
        <button
          class="
            lp-testimonials__dot
            ${index === currentPage ? 'is-active' : ''}
            ${Math.abs(index - currentPage) === 1 ? 'is-near' : ''}
          "
          type="button"
          aria-label="Go to testimonials page ${index + 1}"
          aria-current="${index === currentPage ? 'true' : 'false'}"
          data-lp-testimonials-dot="${index}"
        ></button>
      `
    ).join('');
  }

  function render() {
    normalizeCurrentPage();

    const reviewsPerPage = getReviewsPerPage();
    const pageCount = getPageCount();

    if (currentPage === 0) {
      track.style.transform = 'translateX(0px)';
    } else {
      const targetReview = reviews[currentPage * reviewsPerPage];
      if (!targetReview) return;

      track.style.transform = `translateX(-${targetReview.offsetLeft}px)`;
    }

    previousButton.disabled = currentPage === 0;
    nextButton.disabled = currentPage === pageCount - 1;

    previousButton.setAttribute('aria-disabled', currentPage === 0 ? 'true' : 'false');
    nextButton.setAttribute('aria-disabled', currentPage === pageCount - 1 ? 'true' : 'false');

    renderDots();
  }

  function goToPrevious() {
    if (currentPage === 0) return;
    currentPage -= 1;
    render();
  }

  function goToNext() {
    if (currentPage >= getPageCount() - 1) return;
    currentPage += 1;
    render();
  }

  previousButton.addEventListener('click', goToPrevious);
  nextButton.addEventListener('click', goToNext);

  dotsContainer?.addEventListener('click', (event) => {
    const dot = event.target.closest('[data-lp-testimonials-dot]');
    if (!dot || !dotsContainer.contains(dot)) return;

    currentPage = Number(dot.dataset.lpTestimonialsDot) || 0;
    render();
  });

  viewport.addEventListener('touchstart', (event) => {
    touchStartX = event.changedTouches[0].clientX;
  }, { passive: true });

  viewport.addEventListener('touchend', (event) => {
    touchEndX = event.changedTouches[0].clientX;

    const distance = touchStartX - touchEndX;

    if (Math.abs(distance) < 45) return;

    if (distance > 0) {
      goToNext();
    } else {
      goToPrevious();
    }
  }, { passive: true });

  window.addEventListener('resize', render);

  track.style.transform = 'translateX(0px)';

  requestAnimationFrame(() => {
    currentPage = 0;
    render();
  });

  window.addEventListener('load', () => {
    currentPage = 0;
    render();
  });
}